export const CHOOSE_FLOW_TYPE = 0;
export const TAKE_PHOTOS = 1;
export const CHECK_PHOTOS = 2;
export const PHOTO_ERROR = 3;
export const CONFIRM_HEIGHT = 4;
export const CONFIRM_WEIGHT = 5;
export const PROCESSING = 6;
export const DONE = 7;

export const next = (current) => {
  switch(current) {
    case CHOOSE_FLOW_TYPE: return TAKE_PHOTOS;
    case TAKE_PHOTOS: return CHECK_PHOTOS;
    case CHECK_PHOTOS: return CONFIRM_HEIGHT;
    case CONFIRM_HEIGHT: return CONFIRM_WEIGHT;
    case CONFIRM_WEIGHT: return PROCESSING;
    case PROCESSING: return DONE;
    default: return PHOTO_ERROR;
  }
}